import React, { type FC } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { localeState } from '../state/localeState'

const Home: FC = () => {
  const [locale] = useRecoilState(localeState)

  const { pathname } = useLocation()

  return pathname === '/' ? (
    <h1>Hello web-app-recipients! lang: {locale}</h1>
  ) : (
    <Outlet />
  )
}

export default Home
